import Vue from 'vue';

interface Data {
  stepWatcherVar: string;
  setStepMethod: (step: string) => {};
}

interface RouteTrackingMixin {
  stepRouteTrackingConfig: (stepWatcherVar, setStepMethod) => void;
  updateStepRoute: (step: string, replace: boolean) => void;
  focusFirstElement: () => void;
  scrollToTop: () => void;
}

export default Vue.extend({
  data(): Data {
    return {
      stepWatcherVar: 'currentStep',
      // @ts-ignore
      setStepMethod: this.setStep,
    };
  },
  // Maybe change this to working inside the mounted
  computed: {
    RouteTrackingMixin(): RouteTrackingMixin {
      return {
        stepRouteTrackingConfig: this.stepRouteTrackingConfig,
        updateStepRoute: this.updateStepRoute,
        focusFirstElement: this.focusFirstElement,
        scrollToTop: this.scrollToTop,
      };
    },
    stepWatcher(): string {
      return this[this.stepWatcherVar];
    },
  },
  watch: {
    stepWatcher(): void {
      this.updateStepRoute(this.stepWatcher, false);
    },
  },
  mounted() {
    if (this.$route.params.step > '1' || !this.$route.params.step) {
      this.updateStepRoute('1', true);
    }
    // @ts-ignore
    const FIRST_STEP_INDEX = this.steps.findIndex((step) => {
      return step.stepPosition.toString() === '1';
    });
    // @ts-ignore
    this.steps[FIRST_STEP_INDEX].showBack = false;
  },
  beforeRouteUpdate(to, from, next) {
    this.setStepMethod(to.params.step);
    this.focusFirstElement();
    next();
  },
  methods: {
    stepRouteTrackingConfig(stepWatcherVar, setStepMethod): void {
      this.stepWatcherVar = stepWatcherVar;
      this.setStepMethod = setStepMethod;
    },
    updateStepRoute(step: string, replace: boolean) {
      const ROUTE_CONFIG = {
        name: this.$route.name,
        params: {
          step,
        },
        query: null,
      };

      if (this.$route.query.display_content_keys) {
        ROUTE_CONFIG.query = {
          display_content_keys: true,
        };
      }

      if (replace) {
        this.$router.replace(ROUTE_CONFIG);
      } else {
        this.$router.push(ROUTE_CONFIG);
      }
      this.scrollToTop();
    },
    focusFirstElement() {
      // @ts-ignore
      let ref = this.$refs[`focus-${this.currentStep}`] as any;
      if (ref && (ref.$refs['focus-child'] as any)) {
        ref = ref.$refs['focus-child'] as any;
      }

      if (ref) {
        const FOCUS_IS_FUNCTION = typeof ref.focus === 'function';
        const FOCUS_INPUT_IS_FUNCTION = typeof ref.focusInput === 'function';
        const EL_FOCUS_IS_FUNCTION =
          ref.$el && typeof ref.$el.focus === 'function';
        let focusEl;
        let focusMethod = 'focus';
        if (FOCUS_INPUT_IS_FUNCTION) {
          focusEl = ref;
          focusMethod = 'focusInput';
        } else if (FOCUS_IS_FUNCTION) {
          focusEl = ref;
        } else if (EL_FOCUS_IS_FUNCTION) {
          focusEl = ref.$el as any;
        }
        setTimeout(() => {
          if (focusMethod === 'focus') {
            focusEl.focus();
          } else if (focusMethod === 'focusInput') {
            focusEl.focusInput();
          }
          this.scrollToTop();
        }, 350);
      }
    },
    scrollToTop() {
      if (this.$el.scrollTop !== 0) {
        this.$el.scrollTop = 0;
      }
    },
  },
});
